import "./style.scss";

export const BottomSpace = () => {
    return (
      <div className="container" style={{paddingTop: 120}}> 

      </div>
    );
  };
  